var map = {
	"./3d/alert.png": 93634,
	"./3d/burger.png": 57525,
	"./3d/buy.webp": 13017,
	"./3d/cart.png": 14328,
	"./3d/cart_empty.png": 47022,
	"./3d/cashback.png": 99710,
	"./3d/coin-bottom.webp": 3886,
	"./3d/coin-top.webp": 57460,
	"./3d/coin.webp": 75830,
	"./3d/coin1.webp": 73413,
	"./3d/coin2.webp": 89016,
	"./3d/coins.png": 96970,
	"./3d/cup.webp": 24461,
	"./3d/cup1.webp": 83952,
	"./3d/cup2.webp": 26781,
	"./3d/cup3.webp": 2066,
	"./3d/drink.png": 9066,
	"./3d/flower.webp": 20816,
	"./3d/full_cost.png": 93033,
	"./3d/gift.webp": 61501,
	"./3d/hands.webp": 16847,
	"./3d/hat.png": 6739,
	"./3d/in_hall.png": 84105,
	"./3d/location.png": 40827,
	"./3d/mobile-order.png": 31095,
	"./3d/new.webp": 78071,
	"./3d/note.webp": 34727,
	"./3d/note2.webp": 23639,
	"./3d/pazl.webp": 65406,
	"./3d/percent.webp": 87364,
	"./3d/personalization.png": 70492,
	"./3d/phone.png": 61604,
	"./3d/picked.png": 10322,
	"./3d/t-coin.png": 92824,
	"./3d/thunder.webp": 17095,
	"./3d/time.png": 75321,
	"./3d/tubatay.webp": 56445,
	"./3d/univer.webp": 57892,
	"./3d/warning.png": 82616,
	"./3d/with_him.png": 97765,
	"./5a02330cf834e7784c1d03ec3577e152e7ddc82c.png": 24725,
	"./about-us/baner.webp": 58400,
	"./about-us/burger-m.webp": 48617,
	"./about-us/burger.webp": 34235,
	"./about-us/chart-m.webp": 89512,
	"./about-us/chart.webp": 62734,
	"./about-us/halal.webp": 58598,
	"./about-us/hands.webp": 57792,
	"./about-us/history/1.webp": 70354,
	"./about-us/history/2.webp": 15699,
	"./about-us/history/3.webp": 21616,
	"./about-us/history/4.webp": 35689,
	"./about-us/history/5.webp": 65966,
	"./about-us/line-red.webp": 68614,
	"./about-us/line.webp": 30428,
	"./about-us/lines-m.webp": 67871,
	"./about-us/lines.webp": 18857,
	"./about-us/note.webp": 87974,
	"./about-us/photos/1.webp": 81339,
	"./about-us/photos/2.webp": 42618,
	"./about-us/photos/3.webp": 6789,
	"./about-us/photos/4.webp": 62804,
	"./about-us/photos/5.webp": 73815,
	"./about-us/photos/6.webp": 29494,
	"./about-us/premiya.webp": 74455,
	"./about-us/stories-m.webp": 20465,
	"./about-us/stories.webp": 70499,
	"./about-us/t-family-m.png": 79598,
	"./about-us/t-family-m.webp": 25527,
	"./about-us/t-family.png": 9228,
	"./about-us/t-family.webp": 16385,
	"./about-us/team-m.webp": 40845,
	"./about-us/team.webp": 32783,
	"./about-us/text-bg.webp": 8155,
	"./ads.png": 71976,
	"./ak_bars_tubatay.png": 88898,
	"./ash_balance.png": 15191,
	"./banner.jpg": 76658,
	"./banner.png": 80758,
	"./banner/8783783.png": 41675,
	"./banner/ak_bars_combo.png": 85053,
	"./banner/ak_bars_combo_m.png": 31849,
	"./banner/baner_duck.png": 58757,
	"./banner/baner_duck_m.png": 35505,
	"./banner/banner.png": 66433,
	"./banner/bg-gradient.png": 58601,
	"./banner/m_left.png": 61000,
	"./banner/m_right.png": 9277,
	"./banner/slider/1.jpg": 18600,
	"./banner/slider/2.jpg": 57271,
	"./banner/slider/3.png": 69310,
	"./banner/tourist_gorizontal.png": 95895,
	"./banner/tourist_vertical.png": 98276,
	"./banner_99.png": 39969,
	"./banner_99m.png": 39568,
	"./banner_m.png": 4542,
	"./boy.webp": 83713,
	"./buy.webp": 56683,
	"./certificate/500.png": 93491,
	"./certificate/coin.png": 14991,
	"./certificate/design/1.png": 50402,
	"./certificate/design/2.png": 33337,
	"./certificate/design/3.png": 27088,
	"./certificate/design/4.png": 12463,
	"./certificate/design/5.png": 30918,
	"./certificate/design/6.png": 12125,
	"./certificate/form_bg.png": 90114,
	"./certificates_header.png": 5770,
	"./certificates_header_sm.png": 71075,
	"./checkbox-active.webp": 85181,
	"./checkbox.webp": 20216,
	"./city-map.webp": 88677,
	"./close.webp": 90915,
	"./combo/breakfast/1.jpg": 16362,
	"./combo/breakfast/2.jpg": 40501,
	"./combo/breakfast/3.jpg": 95672,
	"./combo/breakfast/4.jpg": 82923,
	"./combo/combos/1.jpg": 17760,
	"./combo/combos/2.jpg": 751,
	"./combo/combos/3.jpg": 24370,
	"./combo/combos/4.jpg": 36065,
	"./combo/combos/5.jpg": 58020,
	"./combo/combos/6.jpg": 58067,
	"./combo/combos/7.jpg": 86454,
	"./combo/combos/8.jpg": 62917,
	"./combo/taste/1.jpg": 93644,
	"./combo/taste/2.jpg": 36443,
	"./combo/taste/3.jpg": 65310,
	"./combo/taste/4.jpg": 76133,
	"./company/1.webp": 60944,
	"./company/2.webp": 55197,
	"./company/3.webp": 52434,
	"./company/4.webp": 91215,
	"./concepts/1.png": 42375,
	"./concepts/2.png": 5964,
	"./concepts/3.png": 91413,
	"./contacts/1.webp": 96516,
	"./contacts/2.webp": 17153,
	"./contacts/3.webp": 2310,
	"./contacts/4.webp": 60075,
	"./delivery/1.webp": 56521,
	"./delivery/blur_gift.webp": 98978,
	"./delivery/gift.png": 23863,
	"./delivery/gift.webp": 44500,
	"./delivery/packet1-m.webp": 4087,
	"./delivery/packet1.png": 37452,
	"./delivery/packet1.webp": 29153,
	"./delivery/packet2-m.webp": 95390,
	"./delivery/packet2.png": 4487,
	"./delivery/packet2.webp": 94628,
	"./delivery/packet3-m.webp": 45221,
	"./delivery/packet3.png": 28702,
	"./delivery/packet3.webp": 58663,
	"./delivery/percent.png": 68502,
	"./delivery/percent.webp": 79647,
	"./discounts/0001.webp": 68411,
	"./discounts/0003.webp": 21989,
	"./discounts/6.webp": 78462,
	"./discounts/banner.webp": 92634,
	"./discounts/иконки0001.webp": 5134,
	"./discounts/кубки0013.webp": 76784,
	"./discounts/металл0001.webp": 60100,
	"./discounts/молния0001.webp": 53004,
	"./dishes/0014.jpg": 50306,
	"./dishes/00141.jpg": 66797,
	"./dishes/1.jpg": 47476,
	"./dishes/1.png": 83344,
	"./dishes/2.jpg": 25603,
	"./dishes/2.png": 65099,
	"./dishes/3.jpg": 87078,
	"./dishes/3.png": 1442,
	"./dishes/4.jpg": 84877,
	"./dishes/ech.jpg": 77313,
	"./dishes/image.webp": 53159,
	"./dishes/image1.webp": 82966,
	"./dishes/image2.webp": 3991,
	"./dishes/kurai.jpg": 12137,
	"./dishes/speshelty.jpg": 13144,
	"./ech.png": 80370,
	"./ech_active.png": 76337,
	"./guide.png": 23714,
	"./guide/1.png": 9158,
	"./guide/2.png": 92925,
	"./guide/3.png": 71796,
	"./guide/guide.png": 44199,
	"./halal.webp": 98343,
	"./halal_white.webp": 43769,
	"./hands.webp": 87045,
	"./icons/2gis.webp": 90577,
	"./icons/close.png": 905,
	"./icons/coin.webp": 76835,
	"./icons/god.webp": 23452,
	"./icons/heart.webp": 66194,
	"./icons/like.webp": 66805,
	"./icons/location.webp": 17365,
	"./icons/phone.webp": 29854,
	"./icons/smile.webp": 57650,
	"./icons/smile2.webp": 45548,
	"./icons/star.webp": 47838,
	"./icons/telegram.webp": 23465,
	"./icons/whatsapp.webp": 99704,
	"./iftar/banner-bg.png": 71695,
	"./iftar/banner-title-mb.svg": 2144,
	"./iftar/banner-title.svg": 73108,
	"./iftar/iftar-combo.png": 56014,
	"./image.webp": 62334,
	"./invest/advs/1.png": 126,
	"./invest/advs/2.png": 36853,
	"./invest/advs/3.png": 25228,
	"./invest/advs/4.png": 58275,
	"./invest/banner-mobile.png": 9995,
	"./invest/banner.png": 81990,
	"./invest/burger.png": 30195,
	"./invest/hands.png": 30120,
	"./invest/menu/1.png": 60661,
	"./invest/menu/10.png": 68977,
	"./invest/menu/2.png": 58558,
	"./invest/menu/3.png": 27399,
	"./invest/menu/4.png": 47784,
	"./invest/menu/5.png": 41649,
	"./invest/menu/6.png": 20538,
	"./invest/menu/7.png": 84643,
	"./invest/menu/8.png": 24420,
	"./invest/menu/9.png": 78317,
	"./invest/rest/1.png": 26450,
	"./invest/rest/2.png": 90985,
	"./invest/rest/3.png": 66784,
	"./invest/rest/4.png": 78463,
	"./invest/rest/5.png": 41014,
	"./invest/rest/6.png": 56429,
	"./invest/rest/7.png": 93188,
	"./invest/rest/8.png": 93379,
	"./invest/sackcloth-texture-background-m.png": 18671,
	"./invest/sackcloth-texture-background.png": 88281,
	"./invest/salad.png": 17557,
	"./invest/soup.png": 72453,
	"./landing/guide-cover.png": 32684,
	"./landing/guide-day1.png": 23094,
	"./landing/logo-horizontal-white.svg": 44516,
	"./landing/logo-horizontal.svg": 90436,
	"./landing/logo-vertical.svg": 23490,
	"./landing/map-1.jpg": 59782,
	"./landing/misha.jpg": 97514,
	"./landing/pattern-3.png": 5512,
	"./line.webp": 39687,
	"./logo.webp": 31422,
	"./logo136х27.png": 95107,
	"./logo144х30.png": 36142,
	"./logo304х55.png": 77575,
	"./map-m.png": 77594,
	"./map.webp": 46021,
	"./no-photo.jpg": 11430,
	"./note.webp": 10377,
	"./pays/add-card.png": 18786,
	"./pays/no-pay.png": 7009,
	"./pays/pay-card.png": 54571,
	"./pazl.webp": 91556,
	"./posters/1.jpg": 72896,
	"./posters/1.png": 73700,
	"./posters/2.jpeg": 93640,
	"./posters/2.jpg": 86511,
	"./posters/3.png": 9174,
	"./posters/ash_ush.jpg": 42212,
	"./posters/ash_ush_combo.jpg": 43607,
	"./posters/capuchino.jpg": 67465,
	"./posters/daily1.jpg": 321,
	"./posters/daily2.jpg": 50710,
	"./posters/green1.jpg": 75443,
	"./posters/green2.jpg": 75396,
	"./posters/mai.jpg": 64094,
	"./posters/preview.png": 87493,
	"./posters/red1.jpg": 68703,
	"./posters/red2.jpg": 54352,
	"./posters/red3.jpg": 22925,
	"./posters/red4.jpg": 87494,
	"./posters/red5.jpg": 46979,
	"./posters/work1.jpg": 3009,
	"./posters/work2.jpg": 53398,
	"./posters/work3.jpg": 25011,
	"./products/074.webp": 35005,
	"./products/1.webp": 86905,
	"./products/2.webp": 43868,
	"./products/Frame 498.webp": 42478,
	"./rests/088.webp": 28435,
	"./rests/1.jpg": 9067,
	"./rests/2.jpg": 41372,
	"./rests/3.jpg": 38745,
	"./rests/4.jpg": 26154,
	"./rests/5.jpg": 65159,
	"./rests/6.jpg": 86232,
	"./rests/DSC04249.webp": 44614,
	"./rests/DSC07000.jpg": 26219,
	"./rests/DSC07029.png": 36204,
	"./reviews/1.png": 6017,
	"./reviews/2.png": 48586,
	"./reviews/2.webp": 60603,
	"./reviews/3.png": 80499,
	"./reviews/3.webp": 75256,
	"./reviews/4.png": 83100,
	"./reviews/5.webp": 13206,
	"./reviews/6.webp": 38679,
	"./reviews/Frame1.webp": 35651,
	"./reviews/Frame2.webp": 35330,
	"./reviews/Frame3.webp": 60269,
	"./reviews/IMG_2221.png": 39405,
	"./reviews/IMG_2222.png": 57782,
	"./reviews/IMG_2224.png": 2784,
	"./search.webp": 5893,
	"./slider/1.png": 28547,
	"./slider/2.png": 91688,
	"./slider/3.png": 85553,
	"./slider/4.png": 18814,
	"./slider/5.png": 71303,
	"./slider/ak_bars.png": 73395,
	"./slider/ambassador.png": 12271,
	"./slider/capuchino.png": 20314,
	"./slider/stories/1.png": 13521,
	"./slider/stories/2.png": 8762,
	"./slider/stories/3.png": 56515,
	"./slider/stories/4.png": 80268,
	"./slider/stories/5.png": 32533,
	"./souse.png": 19793,
	"./stickers/fresh.webp": 73902,
	"./stickers/meat.webp": 41221,
	"./stickers/new.webp": 8992,
	"./stickers/shef.webp": 60214,
	"./stickers/star.webp": 71050,
	"./stocks/1.png": 22621,
	"./stocks/2.jpeg": 74159,
	"./stocks/200.jpeg": 14279,
	"./stocks/3.png": 20399,
	"./stocks/4.jpg": 41684,
	"./stocks/IMG_2241.jpeg": 57592,
	"./stocks/banner.webp": 82893,
	"./stocks/small/1.png": 96201,
	"./stocks/small/2.png": 5490,
	"./stocks/small/200.jpeg": 29563,
	"./stocks/small/3.png": 3355,
	"./stocks/small/4.jpg": 85664,
	"./stocks/small/IMG_2242.jpeg": 19218,
	"./stories-m.webp": 55008,
	"./stories.webp": 5702,
	"./stories/1.jpg": 36077,
	"./stories/1.webp": 64206,
	"./stories/2.jpg": 66850,
	"./stories/3.jpg": 58559,
	"./stories/4.jpg": 63924,
	"./stories/5.jpg": 52081,
	"./stories/6.jpg": 19878,
	"./stories/7.jpg": 9987,
	"./subcribe/chak-chak.png": 93995,
	"./subcribe/gift.png": 32720,
	"./subcribe/gift2.png": 19904,
	"./subcribe/packet.png": 83594,
	"./subcribe/packet_m.png": 71058,
	"./subcribe/percent-mobile.png": 30460,
	"./subcribe/percent.png": 65287,
	"./subscribe.png": 61114,
	"./svg/Telegram-green.svg": 14688,
	"./svg/Telegram.svg": 29618,
	"./svg/VK.svg": 45698,
	"./svg/add-card.svg": 11943,
	"./svg/arrow-back.svg": 26,
	"./svg/arrow-big.svg": 3039,
	"./svg/arrow-btn.svg": 7241,
	"./svg/arrow-down.svg": 1819,
	"./svg/arrow-green.svg": 95376,
	"./svg/arrow-l.svg": 72789,
	"./svg/arrow-lang.svg": 67331,
	"./svg/arrow-line.svg": 27881,
	"./svg/arrow-r.svg": 38643,
	"./svg/arrow-recom.svg": 41875,
	"./svg/arrow-ref.svg": 29938,
	"./svg/arrow-select.svg": 36963,
	"./svg/arrow-up.svg": 35636,
	"./svg/arrow.svg": 89090,
	"./svg/cart.svg": 30141,
	"./svg/check-done.svg": 79650,
	"./svg/check-item.svg": 40919,
	"./svg/check.svg": 62901,
	"./svg/close-card.svg": 25824,
	"./svg/close.svg": 40545,
	"./svg/coin-green.svg": 97646,
	"./svg/coin-white.svg": 34652,
	"./svg/coins.svg": 16359,
	"./svg/cooking.svg": 59813,
	"./svg/cross.svg": 62169,
	"./svg/delivery.svg": 76911,
	"./svg/devices.svg": 83840,
	"./svg/devices_sm.svg": 45711,
	"./svg/dishes.svg": 41179,
	"./svg/exit.svg": 60223,
	"./svg/favourite_empty_icon.svg": 45050,
	"./svg/favourite_filled_icon.svg": 88641,
	"./svg/filter.svg": 73701,
	"./svg/gray-cross.svg": 71977,
	"./svg/gray-search.svg": 75283,
	"./svg/halal-white.svg": 93289,
	"./svg/halal.svg": 18677,
	"./svg/home.svg": 19050,
	"./svg/i.svg": 22692,
	"./svg/icon-check-green.svg": 43973,
	"./svg/icon-check.svg": 44259,
	"./svg/icon-close.svg": 76567,
	"./svg/line-m.svg": 69635,
	"./svg/line.svg": 86389,
	"./svg/logo-tulpan.svg": 7347,
	"./svg/logo-white.svg": 75282,
	"./svg/logo.svg": 69622,
	"./svg/logo_daily.svg": 36532,
	"./svg/mute.svg": 72660,
	"./svg/phone.svg": 39165,
	"./svg/play.svg": 22113,
	"./svg/points.svg": 50466,
	"./svg/rooms/childish.svg": 72334,
	"./svg/rooms/coworking.svg": 35959,
	"./svg/rooms/prayer-room.svg": 81135,
	"./svg/rooms/tea-room.svg": 74686,
	"./svg/search.svg": 45539,
	"./svg/select-check.svg": 6904,
	"./svg/select-down.svg": 428,
	"./svg/select-green.svg": 74001,
	"./svg/select-white.svg": 26375,
	"./svg/select.svg": 52903,
	"./svg/tableware.svg": 89990,
	"./svg/tg.svg": 26764,
	"./svg/ticoin.svg": 87749,
	"./svg/trash.svg": 41663,
	"./svg/truck.svg": 16168,
	"./svg/update-green.svg": 7830,
	"./svg/update.svg": 52180,
	"./svg/user.svg": 99118,
	"./svg/volume.svg": 11965,
	"./svg/ws.svg": 73293,
	"./tourists/baumana/1.webp": 93306,
	"./tourists/baumana/2.webp": 53755,
	"./tourists/baumana/3.webp": 52056,
	"./tourists/bg-m.webp": 45734,
	"./tourists/bg.png": 13871,
	"./tourists/bg.webp": 10892,
	"./tourists/bottom-m.webp": 68998,
	"./tourists/bottom.webp": 15564,
	"./tourists/burger.webp": 16154,
	"./tourists/center/1.webp": 66274,
	"./tourists/center/2.webp": 31171,
	"./tourists/center/3.webp": 48128,
	"./tourists/city.webp": 83324,
	"./tourists/dishes/1.webp": 46091,
	"./tourists/dishes/2.webp": 13450,
	"./tourists/dishes/3.webp": 46805,
	"./tourists/dishes/4.webp": 2596,
	"./tourists/dishes/5.webp": 66631,
	"./tourists/dishes/6.webp": 67366,
	"./tourists/eat-bg.webp": 32589,
	"./tourists/flowers-bg.webp": 19379,
	"./tourists/guide.png": 93112,
	"./tourists/guide.webp": 89829,
	"./tourists/heart.webp": 21677,
	"./tourists/kaban/1.webp": 42596,
	"./tourists/kaban/2.webp": 60769,
	"./tourists/kaban/3.webp": 91014,
	"./tourists/kitchen-bg-m.webp": 41993,
	"./tourists/kitchen-bg.jpeg": 82539,
	"./tourists/kitchen-bg.webp": 60859,
	"./tourists/kul-sharif.webp": 78511,
	"./tourists/line.webp": 34693,
	"./tourists/main-bg.webp": 58354,
	"./tourists/mobile-bg.png": 84962,
	"./tourists/pen.webp": 67378,
	"./tourists/samovar.webp": 52828,
	"./tourists/silver-bg.webp": 77466,
	"./tourists/smile.webp": 41793,
	"./tourists/smile1.webp": 7900,
	"./tourists/smile2.webp": 87577,
	"./tourists/smile3.webp": 76542,
	"./tourists/souvenirs/1.webp": 95691,
	"./tourists/souvenirs/2.webp": 86346,
	"./tourists/souvenirs/3.webp": 48213,
	"./tourists/souvenirs/4.webp": 32132,
	"./tourists/souvenirs/5.webp": 85831,
	"./tourists/souvenirs/6.webp": 37926,
	"./tourists/street/1.webp": 13400,
	"./tourists/street/2.webp": 97797,
	"./tourists/street/3.webp": 76698,
	"./tourists/text-bg-red.webp": 88022,
	"./tourists/text-bg.webp": 53644,
	"./tourists/text-bg2.webp": 85246,
	"./tourists/text-line.webp": 77189,
	"./tourists/top-m.webp": 7856,
	"./tourists/top.webp": 95574,
	"./tourists/two-line-red.webp": 49914,
	"./tourists/two-lines-red.webp": 29043,
	"./tourists/two-lines.webp": 78877,
	"./tulpan.png": 71104,
	"./tulpan.svg": 92582,
	"./yandex-food/1.png": 7258,
	"./yandex-food/2.png": 15569,
	"./yandex-food/3.png": 75624,
	"./yandex-food/delivery.png": 14235,
	"./yandex-food/icon.png": 82744,
	"./yandex-food/m1.png": 78909,
	"./yandex-food/m2.png": 95142,
	"./yandex-food/m3.png": 80239
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;